import { css } from '@emotion/css';

export const locationPreviewImageStyles = css`
  height: 30rem;
`;
